type titleProps = {
    align?: string,
    lgTitleColor?: string,
    smTitleColor?: string,
    smTitle?: string,
    lgTitle: string
}

export default function Title(props: titleProps) {
    return (
        <div className="relative mx-auto flex max-w-3xl flex-col items-center gap-3 text-center">
            {props.smTitle && (
                <div
                    className="inline-flex items-center gap-3 text-[0.9375rem] font-normal tracking-brand text-primary-400 sm:text-lg"
                    style={props.smTitleColor ? { color: props.smTitleColor } : {}}
                >
                    <span className="h-0.5 w-6 rounded-full bg-current opacity-70" />
                    {props.smTitle}
                    <span className="h-0.5 w-6 rounded-full bg-current opacity-70" />
                </div>
            )}
            <h2
                className="text-[1.875rem] font-bold capitalize leading-tight tracking-brand text-white rtl:leading-[1.6] sm:text-[2.5rem]"
                style={props.lgTitleColor ? { color: props.lgTitleColor } : {}}
            >
                {props.lgTitle}
            </h2>
        </div>
    )
}
